import React from "react";
import { DialogContent } from "@material-ui/core";
import FixedPositionDialog from "../../../../../elements/FixedPositionDialog";
import DialogTitleWithCloseIcon from "../../../../../elements/DialogTitleWithCloseIcon";
import DebtorContainer from "./DebtorContainer";
import I18nText from "../../../../../elements/I18nText";

const DebtorDialog = ({ device, onClose }) => {
  return (
    <>
      <FixedPositionDialog open={true} scroll="body" maxWidth="sm">
        <DialogTitleWithCloseIcon onClose={onClose}>
          <I18nText>devices.settings.billing.sections.debtor</I18nText>
        </DialogTitleWithCloseIcon>
        <DialogContent>
          <DebtorContainer device={device} onClose={onClose} />
        </DialogContent>
      </FixedPositionDialog>
    </>
  );
};

export default DebtorDialog;
